import React, { FC } from "react";

export const SectionContent: FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="space-y-10 sm:space-y-5 sm:divide-y sm:divide-gray-50">
    {children}
  </div>
);
